import { cn } from "@/lib/utils";

interface Properties {
    children?: any
    /** Page frame. Defaults to responsive padding; dense pages pass a tighter one. */
    paddingClassName?: string
    /** Page ground. Defaults to the customer theme; pages with a palette of their own override it. */
    backgroundColor?: string
}

/**
 * Scrollender Inhaltsbereich rechts neben der SideBar. `max-w-full` +
 * `overflow-x-auto` halten breite Inhalte (Tabellen) im Panel, sodass die
 * Seite selbst nie horizontal scrollt. Der Grund kommt als Kundenfarbe aus
 * der CSS-Variablen von Theme.tsx; nur die explizite backgroundColor-Prop
 * (PortfolioDashboard) setzt weiterhin einen dynamischen Inline-Wert.
 */
export default function ContentPanel(properties: Properties) {
    return <div
        className={cn(
            "box-border flex w-full min-w-0 max-w-full flex-1 flex-col overflow-x-auto",
            !properties.backgroundColor &&
                "bg-[color:var(--customer-primary-lighter,hsl(var(--background)))]",
            properties.paddingClassName || "p-4 sm:p-6 lg:p-10",
        )}
        style={properties.backgroundColor ? { backgroundColor: properties.backgroundColor } : undefined}
    >
        {properties.children}
    </div>;
}
